export default __webpack_public_path__ + "static/media/token_wsOHM.cb7d87c5.svg";